import { render } from "./TargetGroupsView.vue?vue&type=template&id=a085717e"
import script from "./TargetGroupsView.vue?vue&type=script&lang=js"
export * from "./TargetGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__